import React from 'react';
import { BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import Home from './features/homeAntigo/home';

export default function Routes()
{
    return(
        <BrowserRouter>
            <Switch>
                <Route path="/" component={Home} exact/>
                <Redirect to="/"/>
            </Switch>
        </BrowserRouter>
    );
}